import { Dataset, JSONObject } from '../../../types/types';
import { getDataKey } from '../../../utils/getDataKey';
import {
  DatasetDataApiRequestData,
  SubsetDataApiRequestData,
} from '../../types/types';
import { getDatasetDataApiRequestData } from './getDatasetDataApiRequestData';

// ID-only request used by locate-by-id flow. Projects only the
// dataset's idItem so we can compute the index of a target row under the
// active filters/sort without paying for full row payloads.
export const getRowIdsApiRequestData = (
  dataset: Dataset,
  activeSorting: any[],
  token: string | null,
  filters?: Record<string, any>,
  limit?: number | null,
  cachedQueryId?: string | null,
  rowId?: string,
  datasetControl?: JSONObject
): DatasetDataApiRequestData | SubsetDataApiRequestData => {
  const requestData = getDatasetDataApiRequestData(
    dataset,
    activeSorting,
    token,
    0,
    filters,
    limit,
    cachedQueryId,
    [getDataKey(dataset)],
    undefined,
    datasetControl
  );

  if (rowId) {
    return {
      ...requestData,
      master: {
        id: rowId,
        idItem: getDataKey(dataset),
      },
    } as SubsetDataApiRequestData;
  }

  return requestData;
};
